module.exports = __webpack_public_path__ + "img/wechat.e263aea3.png";